import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=6a26f087&scoped=true"
import script from "@/controllers/reviews.js?vue&type=script&lang=js&external"
export * from "@/controllers/reviews.js?vue&type=script&lang=js&external"
import style0 from "./Reviews.styles.scss?vue&type=style&index=0&id=6a26f087&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a26f087",
  null
  
)

export default component.exports